import React from "react";
import VideoLessonSubtopics from "../../Components/VideoLessonSubtopics/VideoLessonSubtopics";
import "./LessonSection.css";

function LessonSection({ subtopics, onSelect, selectedVideo}) {
  if (typeof onSelect !== "function") {
    console.error("Error: onSelect is not a function!");
    return null;
  }

  return (
    <div className="lesson-section">
      <VideoLessonSubtopics subtopics={subtopics} onSelect={onSelect} selectedVideo={selectedVideo} />
    </div>
  );
}

export default LessonSection;
